/* @flow */
import React from 'react';
import { observer } from 'mobx-react';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';

import styles from './ElectroAssetFamily.module.scss';

/**
 * ElectroAssetFamilyItem
 *
 * @prop {Object} item
 * @prop {Array<String>} items
 * @prop {Boolean} current
 * @prop {Function} handleOnClick
 * @return {ListItem}
 */
const ElectroAssetFamilyItem: React.StatelessFunctionalComponent<*> = ({
  item,
  items,
  current,
  handleOnClick,
}: Object) => (
  <ListItem
    key={item.id}
    className={current === item.id ? styles.current : ''}
    dense={true}
    divider={true}
    onClick={(evt: SyntheticInputEvent<*>) => {
      handleOnClick(item.id);
    }}
  >
    <ListItemText
      primary={
        <React.Fragment>
          {item.asset_number}
          <br />
          {item.manufacturer}
          <br />
          {item.model}
        </React.Fragment>
      }
    />
    <Checkbox
      disabled={current === item.id}
      checked={items.length > 0 && items.includes(item.id)}
      disableRipple={true}
      tabIndex={-1}
    />
  </ListItem>
);

export default observer(ElectroAssetFamilyItem);
